













import Vue from "vue"
import {mapState} from "vuex"

export default Vue.extend({
  name: 'MissionSlots',
  computed: {
    ...mapState(['activeGameIndex', 'numGames', 'games', 'phase']),
    ...{
      missions () : any[] {
        const missions = []
        const current = this.activeGameIndex
        for (let i = 0; i < this.numGames; i++) {
          missions.push({
            active: i == current,
            won: i < current,
            battling: this.phase === 'battling'
          })
        }
        return missions
      }
    }
  }
})
